<template>

    <!--<div>-->

    <div class="">
<!--        <input type="file" class="custom-file-input" id="inputGroupFile01" required-->
<!--               aria-describedby="inputGroupFileAddon01" @change="handleFileChange">-->
<!--        <label class="custom-file-label" for="inputGroupFile01">-->
<!--            &lt;!&ndash;Choose file&ndash;&gt;-->
<!--            <span v-if="value">{{value.name}}</span>-->
<!--            <span v-else>Select Photo (max file size : 1MB )</span>-->
<!--&lt;!&ndash;            <span>Select Photo (max file size : 90kb )</span>&ndash;&gt;-->
<!--        </label>-->

        <input type="file" class="w-9/12 md:w-auto py-2 px-2 text-white text-sm font-semibold
            bg-green-600 hover:bg-green-900 rounded mb-4" id="inputGroupFile01" @change="handleFileChange">
<!--            <plus-icon class="mr-1"/>-->
<!--            Add announcement-->


        <label class="mx-1 text-sm" for="inputGroupFile01">
            <!--Choose file-->
<!--            <span v-if="value">{{value.name}}</span>-->
            <span>1MB max</span>
            <!--            <span>Select Photo (max file size : 90kb )</span>-->
        </label>

    </div>
    <!--</div>-->

</template>

<script>
    export default {
        name: "file-selector",
        props: {
            // value: File
        },

        methods: {
            handleFileChange(e) {
                if(e.target.files[0].size < 1000001) {
                    this.$emit('input', e.target.files[0]);

                    this.$emit('file_url', URL.createObjectURL(e.target.files[0]));
                }else{
                    this.$swal({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        title: 'File size '+ (e.target.files[0].size / 1000000).toFixed(2) +'MB is greater than 1MB',

                    });
                }
            }
        }
    }
</script>

<style scoped>

    /*.file-select > .select-button {*/
    /*    padding: 1rem;*/

    /*    color: white;*/
    /*    background-color: #2ea169;*/

    /*    border-radius: .3rem;*/

    /*    text-align: center;*/
    /*    font-weight: bold;*/
    /*}*/

    /*.file-select > input[type="file"] {*/
    /*    !*display: none;*!*/
    /*}*/

</style>
